import { render, staticRenderFns } from "./AntiFraudPolicy.vue?vue&type=template&id=6057fa07&"
import script from "./AntiFraudPolicy.vue?vue&type=script&lang=js&"
export * from "./AntiFraudPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports